import React, { Component } from "react";
import Wrapper from "../../hoc/Wrapper/Wrapper";
import { connect } from "react-redux";

class ContactPage extends Component {
  render() {
    return (
      <Wrapper>
        <div>contact</div>
      </Wrapper>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loading: state.auth.loading,
    error: state.auth.error,
    tokenData: state.auth.token,
    isAuthenticated: state.auth.token !== null,
  };
};

export default connect(mapStateToProps)(ContactPage);
